import { FC } from 'react';
import { useTranslation } from 'react-i18next';
const ReturnTranslatedText = ({
  text,
  origintext,
}: {
  text: string;
  origintext?: string;
}) => {
  const { t } = useTranslation();
  return <div>{t(text, origintext || '')}</div>;
};

export default ReturnTranslatedText;
